import { MatTableDataSource } from '@angular/material/table';
import { ObjectPathService } from '../../service/common/deep-path/deep-path.service';
import { Netzbetreiber } from '../../domain/model/netzbetreiber';
import { NetzbetreiberFilter } from '../../service/netzbetreiber/netzbetreiber-filter';
import moment from 'moment';

export class NetzbetreiberDataSource extends MatTableDataSource<Netzbetreiber> {

    sortingDataAccessor: ((data: Netzbetreiber, sortHeaderId: string) => string | number) =
        (data: Netzbetreiber, sortHeaderId: string): string | number => {

            const value = ObjectPathService.objectPath(data, sortHeaderId);

            if (value === undefined || value === null) {
                return '';
            }

            if (typeof value === 'string' && !value.trim()) {
                return value;
            }

            if (sortHeaderId === 'netzbetreibernummer') {
                // Vergib mir, denn ich weiss, was ich tue:
                return value.padStart(25, '0');
                // die Sortierung schlaegt bei Mischformen fehl, wenn netzbetreibernummer Buchstaben enthalten
                // wenn man alles auf die gleiche Laenge padded, kann man alles als String sortieren.
            }

            if (sortHeaderId === 'dienstleistungsmoduleBeschreibung') {
                if (!value) {
                    return 0;
                } else {
                    return value.length;
                }
            }

            if (sortHeaderId === 'dienstleistungsart') {
                return value.title;
            }

            return isNaN(+value) ? value.toLowerCase() : +value;
        };

    filterPredicate = (data: Netzbetreiber, filter: string): boolean => {
        const nbFilter: NetzbetreiberFilter = JSON.parse(filter);
        if (filter) {
            let filtered = true;
            if (nbFilter.name && nbFilter.name.trim() !== '') {
                filtered = filtered && this.contains(data.name, nbFilter.name);
            }
            if (nbFilter.stwId && nbFilter.stwId.trim() !== '') {
                filtered = filtered && this.contains(data.stadtwerkeId, nbFilter.stwId);
            }
            if (nbFilter.teilgebiet && nbFilter.teilgebiet.trim() !== '') {
                filtered = filtered && this.contains(data.teilgebiet, nbFilter.teilgebiet);
            }
            if (nbFilter.netzbetreibernummer && nbFilter.netzbetreibernummer.trim() !== '') {
                filtered = filtered && this.contains(data.netzbetreibernummer, nbFilter.netzbetreibernummer);
            }
            if (nbFilter.geschaeftspartnerId && nbFilter.geschaeftspartnerId.trim() !== '') {
                filtered = filtered && this.contains(data.geschaeftspartnerId, nbFilter.geschaeftspartnerId);
            }
            if (nbFilter.lastImportDate && this.isDateValid(nbFilter.lastImportDate.start)) {
                if (data.lastImportDate === null) {
                    filtered = false;
                } else {
                    filtered = filtered && moment(data.lastImportDate).isSameOrAfter(moment(nbFilter.lastImportDate.start), 'day');
                }
            }
            if (nbFilter.lastImportDate && this.isDateValid(nbFilter.lastImportDate.end)) {
                if (data.lastImportDate === null) {
                    filtered = false;
                } else {
                    filtered = filtered && moment(data.lastImportDate).isSameOrBefore(moment(nbFilter.lastImportDate.end), 'day');
                }
            }
            if (nbFilter.dienstleistungsart && nbFilter.dienstleistungsart.trim() !== '') {
                if (nbFilter.dienstleistungsart === '-') {
                    filtered = filtered && data.dienstleistungsart === null;
                } else {
                    filtered = filtered && data.dienstleistungsart !== null && this.contains(data.dienstleistungsart.title, nbFilter.dienstleistungsart);
                }
            }
            if (nbFilter.dienstleistungsmoduleBeschreibung && nbFilter.dienstleistungsmoduleBeschreibung.length > 0) {
                const moduleTitles = data.dienstleistungsmoduleBeschreibung.map(value => value.title);
                filtered = filtered && nbFilter.dienstleistungsmoduleBeschreibung.every(v => moduleTitles.includes(v));
            }
            return filtered;
        }
        return true;
    };

    private contains(value: string | null, filter: string): boolean {
        if (value == null) {
            return false;
        }
        return value.toLowerCase().indexOf(filter.toLowerCase().trim()) !== -1;
    }

    private isDateValid(date?: string) {
        return date !== null && date !== '';
    }
}
